import { CatalogBghListItem } from '~/features/catalog/components/CatalogBghListItem';
import type { ArticleType } from '~/common/types/baseArticle';
import type { AghArticle } from '~/common/types/aghArticle';
import type { BghArticle } from '~/common/types/bghArticle';
import type { IVirtualBaseListRenderItemProps} from '~/common/components/VirtualBaseList';
import { VirtualBaseList } from '~/common/components/VirtualBaseList';
import { CatalogAghListItem } from '~/features/catalog/components/CatalogAghListItem';

type CatalogListProps = {
  articles: (AghArticle | BghArticle)[];
  isAuthenticated: boolean;
  articleType: ArticleType;
};

export default function CatalogList({ articles, isAuthenticated, articleType }: Readonly<CatalogListProps>) {
  const renderItem = (data: IVirtualBaseListRenderItemProps) => {
    const article = articles[data.index];

    return (
      <div>
        {articleType === 'bgh' ? (
          <CatalogBghListItem
            key={(article as BghArticle).articleNumber}
            article={article as BghArticle}
            isAuthenticated={isAuthenticated}
            index={data.index}
          />
        ) : (
          <CatalogAghListItem
            key={(article as AghArticle).articleNumber}
            article={article}
            isAuthenticated={isAuthenticated}
            index={data.index}
          />
        )}
        <hr />
      </div>
    );
  };

  return (
    <VirtualBaseList
      itemCount={articles.length}
      renderItem={(data: IVirtualBaseListRenderItemProps) => renderItem(data)}
      useWindowScroll
      overscan={1000}
    />
  );
}
